module.exports = __webpack_public_path__ + "media/images/icons/mapaSenzoru-9529eececc7018d0521e63af04f312e2.svg";